import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getReferences = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/references', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getReference = id => {
  return api.http.get(`/references/${id}`)
}

export const searchReferences = term => {
  return api.http.get('/references/select_search', {
    params: {
      term
    }
  })
}

export const getSelectReferences = (term, callback) => {
  searchReferences(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteReference = id => {
  return api.http.delete(`/references/${id}`)
}

export const restoreReference = id => {
  return api.http.put(`/references/${id}/restore`)
}

export const editReference = reference => {
  return api.http.put(`/references/${reference._id}`, reference)
}

export const addReference = reference => {
  return api.http.post('/references', reference)
}



// WEBPACK FOOTER //
// ./src/api/references.js